module.exports = __webpack_public_path__ + "static/media/icon_search.520a2b37.png";